// @index(!data): export * from ${relpath}
export * from './breadcrumbs'
// /index